import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterViewIndex from '@/views/RouterViewIndex.vue';
import i18n from '@/i18n/index.js';
Vue.use(VueRouter);

export default [
  {
    path: 'introduction',
    name: 'introduction-index',
    component: RouterViewIndex,
    redirect: {
      name: 'introduction',
    },
    children: [
      {
        path: '',
        name: 'introduction',
        component: () => import('@/views/Introduction/Introduction.vue'),
        meta: {
          title: i18n.t('關於IGQE'),
        },
      },
      {
        path: 'policy/:id',
        name: 'policy',
        component: () => import('@/views/Introduction/Policy.vue'),
        meta: {
          key: 'policy',
          title: i18n.t('政策文件'),
        },
      },
    ],
  },
];
